<template>
  <div class="ESearch contentBack contentBack2">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>企业管理 </el-breadcrumb-item>
      <el-breadcrumb-item class="breadSelected">企业查询 </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="Econtent">
      <!-- 左 -->
      <div id="Eleft">
        <el-tree :data="queryData" node-key="id" @node-click="handleNodeClick">
          <!-- <template slot-scope="{node, data}">
    <el-tooltip effect="dark" :content="node.labe" placement="right">
      <span>{{node.label}}</span>
    </el-tooltip>
  </template> -->
        </el-tree>
      </div>
      <!-- 右 -->
      <div id="Eright">
        <div class="Eresult">
          <div class="listTitle titleBold gjcx">
            <div class="newtitle">筛选条件</div>
            <div class="query-tag">
              <el-tag
                v-for="(it, i) in cnty"
                :key="i + '1'"
                closable
                type="info"
                @close="handleClose(it)"
              >
                {{ it }}
              </el-tag>
              <el-tag
                v-for="(hyfl, j) in hyfl"
                :key="j + '2'"
                closable
                type="info"
                @close="handleClose(hyfl)"
              >
                {{ hyfl }}
              </el-tag>

              <el-tag
                v-for="(qyflChild, a) in qyflChild"
                :key="a"
                closable
                type="info"
                @close="handleClose(qyflChild)"
              >
                {{ qyflChild }}
              </el-tag>
              <el-tag
                v-for="(qyfl, b) in qyfl"
                :key="b + '4'"
                closable
                type="info"
                @close="handleClose(qyfl)"
              >
                {{ qyfl }}
              </el-tag>
              <el-tag
                v-for="(ipcdes, f) in ipcdes"
                :key="f + '10'"
                closable
                type="info"
                @close="handleClose(ipcdes)"
              >
                {{ ipcdes }}
              </el-tag>
              <el-tag
                v-for="(zdhy, i) in zdhy"
                :key="i + '99'"
                closable
                type="info"
                @close="handleClose(zdhy)"
              >
                {{ zdhy }}
              </el-tag>
            </div>

            <!-- <div class="query-tag" >
             
            
          </div> -->
            <!-- <div class="query-tag" >
           
            
          </div> -->
            <!-- <div class="query-tag" >
           
            
          </div> -->
            <!-- <div class="query-tag" >
              <el-tag
              v-for="(item, index) in zdhy"
              :key="index"
              closable
              type="info"
              @close="handleClose(item)">
              {{item}}
            </el-tag>
            
          </div> -->
            <!-- <span style="margin-left:15px" v-for="(item, index) in querySelect" :key="index">
              {{item}}
            </span> -->
          </div>
          <!-- 高级查询（一直都存在） -->
          <div class="listTitle titleBold gjcx">
            高级查询
            <span @click="handlegjcxShow">[展开/收起]</span>
          </div>
          <div class="gjcxContent" v-if="gjcxShow">
            <el-form
              ref="form"
              :model="form"
              label-width="82px"
              label-position="left"
            >
              <!-- 基本信息 -->
              <div style="display: flex; justify-content: space-between">
                <el-form-item class="elform30" label="企业名称：" size="mini">
                  <el-input
                    v-model="form.ap"
                    placeholder="输入企业名称"
                    prefix-icon="el-icon-search"
                    @change="applicantSearch()"
                  ></el-input>
                </el-form-item>
                <!-- 模糊查询结果 -->
                <div class="startFirms-new location" v-show="startFirms">
                  <ul>
                    <li
                      v-for="(item, index) of firms"
                      :key="index"
                      @click="chooseKeyfirm(index)"
                    >
                      {{ item.ap }}
                    </li>
                  </ul>
                </div>
                <el-form-item class="elform30" label="法人代表：" size="mini">
                  <el-input
                    v-model="form.frdb"
                    placeholder="输入法人名称"
                  ></el-input>
                </el-form-item>
                <el-form-item class="elform30" label="企业地址：" size="mini">
                  <el-input
                    v-model="form.apad"
                    placeholder="输入企业地址"
                  ></el-input>
                </el-form-item>
              </div>

              <!-- 注册信息 -->
              <div style="display: flex; justify-content: space-between">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="注册日期:" size="mini">
                      <el-row>
                        <!-- span的值为24 -->
                        <el-col :span="11">
                          <el-date-picker
                            type="date"
                            placeholder="年/月/日"
                            v-model="form.sclrq"
                            style="width: 100%"
                            value-format="yyyy-MM-dd"
                          ></el-date-picker>
                        </el-col>
                        <el-col :span="2" style="text-align: center">
                          至
                        </el-col>
                        <el-col :span="11">
                          <el-date-picker
                            type="date"
                            placeholder="年/月/日"
                            v-model="form.eclrq"
                            style="width: 100%"
                            value-format="yyyy-MM-dd"
                          ></el-date-picker>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" style="color: rgba(255, 255, 255, 0)"
                    >1</el-col
                  >
                  <el-col :span="7">
                    <el-form-item
                      label-width="120px"
                      label="注册资金(万元):"
                      size="mini"
                    >
                      <el-row>
                        <el-col :span="11">
                          <el-input
                            placeholder="输入金额"
                            v-model="form.szczb"
                          ></el-input>
                        </el-col>
                        <el-col :span="2"> 至 </el-col>
                        <el-col :span="11">
                          <el-input
                            placeholder="输入金额"
                            v-model="form.ezczb"
                          ></el-input>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" style="color: rgba(255, 255, 255, 0)"
                    >1
                  </el-col>
                  <el-col :span="7">
                    <el-form-item
                      label="社会信用代码："
                      size="mini"
                      label-width="110px"
                    >
                      <el-input
                        placeholder="输入社会信用代码"
                        v-model="form.xydm"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <el-form-item label-width="0">
                <el-button
                  style="background: #1890ff; padding: 10px 24px"
                  type="primary"
                  @click="onSubmit"
                  >查 询</el-button
                >
                <el-button
                  style="padding: 10px 24px; margin-left: 46px"
                  @click="resetData"
                  >重 置</el-button
                >
              </el-form-item>
            </el-form>
          </div>

          <!-- 查询结果(只有高级查询的时候不显示) -->

          <div v-if="isSearch">
            <div class="listTitle titleBold gjcx">
              查询结果
              <div style="margin-left: 20px">
                注：商标、专利数据统计依据为企业注册地址在绵阳
              </div>
              <!-- <div v-if="paramslabel!=''" style="float:none;font-size:14px;">{{"———— "+paramslabel}}</div> -->
              <div class="out-excel" style="flex: 1">
                <el-button
                  style="
                    float: right;
                    margin-right: 20px;
                    height: 30px;
                    line-height: 30px;
                    padding: 0 16px;
                    border-radius: 2px;
                    margin-top: 2px;
                    border: 1px solid #1773d5;
                    color: #1773d5;
                  "
                  @click="daochu"
                  >导出全部</el-button
                >
                <el-button
                  style="
                    float: right;
                    margin-right: 20px;
                    height: 30px;
                    line-height: 30px;
                    padding: 0 16px;
                    border-radius: 2px;
                    margin-top: 2px;
                    border: 1px solid #1773d5;
                    color: #1773d5;
                  "
                  @click="daochu"
                  >导出已选</el-button
                >
              </div>
            </div>
            <div class="cxResultContent">
              <!-- 数据汇总 -->
              <!-- 专利xx件。 授权专利xx件（发明授权专利xx件。实用新型授权专利xx件。外观设计授权专利xx件）。 累计有效专利xx件。PCT申请专利xx件。 -->

              <table></table>
              <div style="margin: 11px 20px; font-size: 14px; color: #000">
                查询结果中，企业共
                <span class="bloooo">{{ dataSummary.apNum || "0" }}</span
                >家，专利<span class="bloooo">{{
                  dataSummary.ptTotal || "0"
                }}</span
                >件。授权专利<span class="bloooo">{{
                  dataSummary.ptAuth || "0"
                }}</span
                >件（授权发明专利<span class="bloooo">{{
                  dataSummary.ptInvention || "0"
                }}</span>
                件，授权实用新型专利<span class="bloooo">{{
                  dataSummary.ptUtility || "0"
                }}</span
                >件，授权外观设计专利<span class="bloooo">{{
                  dataSummary.ptOutlook || "0"
                }}</span
                >件）累计有效专利<span class="bloooo">{{
                  dataSummary.ptValid || "0"
                }}</span
                >件，PCT申请专利<span class="bloooo">{{
                  dataSummary.ptPct || "0"
                }}</span
                >件。商标共<span class="bloooo">{{ dataSummary.tmTotal }}</span
                >件，有效商标<span class="bloooo">{{
                  dataSummary.tmValid || "0"
                }}</span
                >件。
              </div>
              <!-- formResult -->
              <el-table
                ref="multipleTable1"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                border
                @sort-change="sort"
              >
                <!-- 选择框 -->
                <el-table-column type="selection" width="40" :resizable="false">
                </el-table-column>
                <!-- 序号 -->
                <el-table-column
                  label="序号"
                  type="index"
                  width="50"
                  :resizable="false"
                >
                  <template slot-scope="scope">
                    <span>{{
                      (pageNum - 1) * pageSize + scope.$index + 1
                    }}</span>
                  </template></el-table-column
                >
                <!-- 企业名称 -->
                <el-table-column
                  prop="ap"
                  label="企业名称"
                  min-width="120"
                  show-overflow-tooltip
                  :resizable="false"
                >
                  <template slot-scope="scope">
                    <div
                      class="apStyle"
                      @click="openDetails(scope.row)"
                      style="
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ scope.row.ap }}
                    </div>
                  </template>
                </el-table-column>
                <!-- 法人代表 -->
                <el-table-column
                  prop="frdb"
                  label="法人代表"
                  min-width="80"
                  :resizable="false"
                >
                </el-table-column>
                <!-- 注册日期 -->
                <el-table-column
                  prop="clrq"
                  label="注册日期"
                  sortable="custom"
                  min-width="103"
                  :resizable="false"
                ></el-table-column>
                <!-- 经营状态 -->
                <el-table-column
                  prop="ls"
                  label="经营状态"
                  width="80"
                  show-overflow-tooltip
                  :resizable="false"
                ></el-table-column>
                <!-- 企业专利数 -->
                <el-table-column
                  prop="ptnum"
                  label="企业专利数"
                  sortable="custom"
                  min-width="120"
                  :resizable="false"
                ></el-table-column>
                <!-- 有效专利数 -->
                <el-table-column
                  prop="ptyxnum"
                  label="有效专利数"
                  sortable="custom"
                  min-width="120"
                  :resizable="false"
                ></el-table-column>
                <!-- 企业商标数 -->
                <el-table-column
                  prop="tmnum"
                  label="企业商标数"
                  sortable="custom"
                  min-width="120"
                  :resizable="false"
                ></el-table-column>
                <!-- 有效商标数 -->
                <el-table-column
                  prop="tmyxnum"
                  label="有效商标数"
                  sortable="custom"
                  min-width="120"
                  :resizable="false"
                ></el-table-column>
                <!-- 注册资金（万元） -->
                <el-table-column
                  prop="zczb"
                  label="注册资金（万元）"
                  min-width="140"
                  :resizable="false"
                ></el-table-column>
                <!-- 注册地址 -->
                <el-table-column
                  prop="apad"
                  label="注册地址"
                  show-overflow-tooltip
                  min-width="150"
                  :resizable="false"
                ></el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 查询结果结束-->
          <!-- 分页 -->
          <div v-if="isSearch" class="page-pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
            <el-button size="mini" type="primary" style="margin-left: 5px"
              >确定</el-button
            >
          </div>
          <!-- 分页结束 -->
          <!-- a.企业信息弹框 -->

          <!-- 企业信息弹框结束 -->
          <!-- 商标基本信息弹框 -->

          <!-- 商标基本信息弹框 结束-->
          <!-- 专利基本信息弹框 -->

          <!-- 专利基本信息弹框 结束 -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Bus from '../request/bus.js'
import { Message } from "element-ui";

export default {
  name: "enterPriseSearch",
  data() {
    return {
      queryData: [
        {
          id: 1,
          label: "全部企业",
        },
        {
          id: 2,
          label: "区域分类",
          children: [
          ],
        },
        {
          id: 3,
          label: "国民经济行业分类",
          children: [
            {
              id: 21,
              label: "A农、林、牧、渔业",
            },
            {
              id: 22,
              label: "B采矿业",
            },
            {
              id: 23,
              label: "C制造业",
            },
            {
              id: 24,
              label: "D电力、热力、燃气及水生产和供应业",
            },
            {
              id: 25,
              label: "E建筑业",
            },
            {
              id: 26,
              label: "F批发和零售业",
            },
            {
              id: 27,
              label: "G交通运输、仓储和邮政业",
            },
            {
              id: 28,
              label: "H住宿和餐饮业",
            },
            {
              id: 29,
              label: "I信息传输、软件和信息技术服务业",
            },
            {
              id: 30,
              label: "J金融业",
            },
            {
              id: 31,
              label: "K房地产业",
            },
            {
              id: 32,
              label: "L租赁和商务服务业",
            },
            {
              id: 33,
              label: "M科学研究和技术服务业",
            },
            {
              id: 34,
              label: "N水利、环境和公共设施管理业",
            },
            {
              id: 35,
              label: "O居民服务、修理和其他服务业",
            },
            {
              id: 36,
              label: "P教育",
            },
            {
              id: 37,
              label: "Q卫生和社会工作",
            },
            {
              id: 38,
              label: "R文化、体验和娱乐业",
            },
            {
              id: 39,
              label: "S公共管理、社会保障和社会组织",
            },
            {
              id: 40,
              label: "T国际组织",
            },
          ],
        },
        // {
        //   id: 4,
        //   label: "重点产业分类",
        //   children: [
        //     {
        //       id: 41,
        //       label: "电子信息",
        //     },
        //     {
        //       id: 42,
        //       label: "装备制造",
        //     },
        //     {
        //       id: 43,
        //       label: "生物医药",
        //     },
        //     {
        //       id: 99,
        //       label: "能源化工",
        //     },
        //   ],
        // },
        {
          id: 5,
          label: "企业分类",
          children: [
            {
              id: 44,
              label: "全部",
            },

            {
              id: 45,
              label: "规上企业",
              children: [
                {
                  id: 46,
                  label: "电子信息",
                },
                {
                  id: 47,
                  label: "装备制造",
                },
                {
                  id: 48,
                  label: "生物医药",
                },
                {
                  id: 98,
                  label: "能源化工",
                },
              ],
            },
            {
              id: 49,
              label: "专精特新企业",
            },
            {
              id: 50,
              label: "高新技术企业",
            },
            {
              id: 51,
              label: "融合发展企业",
            },
          ],
        },
        {
          id: 6,
          label: "IPC分类",
          children: [
            {
              id: "",
              label: "",
            },
            {
              id: "",
              label: "",
            },
            {
              id: "",
              label: "",
            },
          ],
        },
        //  {
        //   id: 6,
        //   label: "战略性新兴产业分类",
        //   children: [
        //     {
        //       id: 52,
        //       label: "全部",
        //     },
        //     {
        //       id: 53,
        //       label: "新一代信息技术产业",
        //     },
        //     {
        //       id: 54,
        //       label: "高端装备制造产业",
        //     },
        //     {
        //       id: 55,
        //       label: "新材料产业",
        //     },
        //     {
        //       id: 56,
        //       label: "生物产业",
        //     },
        //     {
        //       id: 57,
        //       label: "新能源汽车产业",
        //     },
        //     {
        //       id: 58,
        //       label: "新能源产业",
        //     },
        //     {
        //       id: 59,
        //       label: "节能环保产业",
        //     },
        //     {
        //       id: 60,
        //       label: "数字创意产业",
        //     },
        //     {
        //       id: 61,
        //       label: "相关服务业",
        //     },
        //   ],
        // },
      ],
      optionsRegion: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      ////////////////////////\
      startFirms: false, //模糊查询结果
      firms: [],
      gjcxShow: true,
      form: {
        uid: localStorage.getItem("uid"),
        ap: null,
        frdb: null,
        apad: null,
        sclrq: null,
        eclrq: null,
        szczb: null,
        ezczb: null,
        xydm: null,
      },
      tablezldata: [],
      tablesbdata: [],
      tableData: [],
      multipleSelection: [],
      multipleSelection1: [],
      multipleSelection2: [],
      currentPage: 1,
      currentPage1: 1,
      currentPage2: 1,
      // 数据汇总
      dataSummary: {},
      paramslabel: "",
      total: 0,
      pageSize: 10,
      pageSize1: 10,
      pageSize2: 10,
      pageNum: 1,
      pageNum1: 1,
      pageNum2: 1,
      order: "",
      orderType: "",
      firmdetails: false,
      activeName: "first", //tab默认
      detailsFirm: {},
      sbbasicData: false,
      zlbasicData: false,
      isSearch: false,
      typeSearch: false,
      isGjcx: false,
      reSearch: false,
      detailszlNum: [
        { total: "", faming: "", waiguan: "", shiyong: "" },
        { zaishen: "", youxiao: "", wuxiao: "" },
      ],
      detailssbNum: { zaishen: "", youxiao: "", wuxiao: "" },
      zlTypeselect: "",
      zlLawselect: "",
      totalzl: 0,
      totalsb: 0,
      zlbasicDataDetails: {},
      sbbasicDataDetails: {},
      sbLawselect: "",
      querySelect: [],
      hyfl: [],
      cnty: [],
      zdhy: [],
      qyfl: [],
      ipc: [],
      ipcdes: [],
      tagsTextArray: [],
      qyflChild: [],
      enterbasicDataDetails: [],
      options: [
        {
          value: "",
          label: "",
          children: [
            // {
            //       id: 99,
            //       label: "电1子规上",
            //     },
          ],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
        {
          value: "",
          label: "",
          children: [],
        },
      ],
    };
  },

  methods: {
    // 获取树数据ipc分类
    applicantIpc() {
      this.$GET("applicant/ipcbp", {
        token: localStorage.getItem("token"),
        pid: "",
      }).then((res) => {
        let ipcTreedata = res.data;
        let ipcdata = [];
        let ipcCode = [];

        ipcTreedata.forEach((e) => {
          e.parent.name = e.parent.code + "-" + e.parent.name;
          e.child.forEach((i) => {
            i.label = i.code + "-" + i.name;
            i.value = i.code + "-" + i.name;
            i.id = i.code;
            delete i.name;
            delete i.id;
          });

          ipcdata.push(e.parent.name);
          ipcCode.push(e.parent.code);
        });

        this.options.forEach((item, index) => {
          this.options[index].children = ipcTreedata[index].child;
          ipcdata.forEach((ele, index) => {
            this.options[index].label = ipcdata[index];
          });
          ipcCode.forEach((element, index) => {
            this.options[index].value = ipcCode[index];
          });
        });

        // console.log(this.options);
        this.queryData.forEach((ele) => {
          if (ele.id == 6) {
            ele.children = this.options;
          }
        });
      });
    },
    // 申请人模糊查询
    applicantSearch() {
      this.$GET("applicant/searchField", {
        keyword: this.form.ap,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        this.firms = res.data.list;
        if (this.firms.length === 0) {
          this.startFirms = false;
        } else {
          this.startFirms = true;
        }
      });
    },
    chooseKeyfirm(index) {
      this.form.ap = this.firms[index].ap;
      this.startFirms = false;
    },
    handleClose(item) {
      if (
        item === "市中区" ||
        item === "沙湾区" ||
        item === "五通桥区" ||
        item === "金口河区" ||
        item === "犍为县" ||
        item === "井研县" ||
        item === "夹江县" ||
        item === "沐川县" ||
        item === "峨边彝族自治县" ||
        item === "马边彝族自治县" ||
        item === "峨眉山市"
      ) {
        this.cnty.splice(this.cnty.indexOf(item), 1);
        this.getFirmMsg();
        // console.log('cnty',this.cnty)
      } else if (
        item === "农、林、牧、渔业" ||
        item === "采矿业" ||
        item === "制造业" ||
        item === "电力、热力、燃气及水生产和供应业" ||
        item === "建筑业" ||
        item === "批发和零售业" ||
        item === "交通运输、仓储和邮政业" ||
        item === "住宿和餐饮业" ||
        item === "信息传输、软件和信息技术服务业" ||
        item === "金融业" ||
        item === "房地产业" ||
        item === "租赁和商务服务业" ||
        item === "科学研究和技术服务业" ||
        item === "水利、环境和公共设施管理业" ||
        item === "居民服务、修理和其他服务业" ||
        item === "教育" ||
        item === "卫生和社会工作" ||
        item === "文化、体验和娱乐业" ||
        item === "公共管理、社会保障和社会组织" ||
        item === "国际组织"
      ) {
        this.hyfl.splice(this.hyfl.indexOf(item), 1);
        this.getFirmMsg();
        // this.hyfl = this.hyfl
        // console.log('hyfl',this.hyfl)
      } else if (
        item === "规上企业-电子信息" ||
        item === "规上企业-装备制造" ||
        item === "规上企业-生物医药" ||
        item === "规上企业-能源化工"
      ) {
        this.qyflChild.splice(this.qyflChild.indexOf(item), 1);
        this.getFirmMsg();
        // console.log('qyflChild',this.qyflChild)
      } else if (
        item === "重点产业-电子信息" ||
        item === "重点产业-装备制造" ||
        item === "重点产业-生物医药" ||
        item === "重点产业-能源化工"
      ) {
        this.zdhy.splice(this.zdhy.indexOf(item), 1);
        this.getFirmMsg();
      } else if (
        item === "专精特新企业" ||
        item === "高新技术企业" ||
        item === "融合发展企业"
      ) {
        this.qyfl.splice(this.qyfl.indexOf(item), 1);
        this.getFirmMsg();
        // console.log('qyfl',this.qyfl)
      } else if (item) {
        this.ipcdes.splice(this.ipcdes.indexOf(item), 1);
        // 对ipc分类中的编码进行删除
        this.ipc.splice(this.ipc.indexOf(item.split("-")[0]), 1);
        this.getFirmMsg();
      }
      // this.hyfl = this.hyfl.splice(this.hyfl.indexOf(item),1)
      // this.hyfl= this.hyfl.join()
      // console.log('----',this.hyfl)
      //  this.getFirmMsg();
      //  this.ipcdes.splice(this.ipcdes.indexOf(item), 1);
    },
    // 添加筛选条件
    handleNodeClick(data, node) {
      // console.log("-----data", data);
      //  console.log("-----node", node);
      // if (node.level !== 1 && data.label !== '全部') {
      //   this.querySelect.push(data.label)
      //   this.querySelect = [...new Set(this.querySelect)]
      // }
      this.typeSearch = true;
      // var hyfl=[];
      if (
        data.id == 21 ||
        data.id == 22 ||
        data.id == 23 ||
        data.id == 24 ||
        data.id == 25 ||
        data.id == 26 ||
        data.id == 27 ||
        data.id == 28 ||
        data.id == 29 ||
        data.id == 30 ||
        data.id == 31 ||
        data.id == 32 ||
        data.id == 33 ||
        data.id == 34 ||
        data.id == 35 ||
        data.id == 36 ||
        data.id == 37 ||
        data.id == 38 ||
        data.id == 39 ||
        data.id == 40
      ) {
        if (node.level !== 1 && data.label !== "全部") {
          this.hyfl.push(data.label.slice(1));
          this.hyfl = [...new Set(this.hyfl)];
        }
        // console.log('-----',this.hyfl)
        // this.paramslabel = searchName.slice(1);
        if (this.tableData.length > 0) {
          this.resetSort();
        }
        this.getFirmMsg();
      } else if (
        data.id == 41 ||
        data.id == 42 ||
        data.id == 43 ||
        data.id == 99
      ) {
        if (node.level !== 1 && data.label !== "全部") {
          this.zdhy.push("重点产业-" + data.label);
          this.zdhy = [...new Set(this.zdhy)];
        }
        if (this.tableData.length > 0) {
          this.resetSort();
        }

        this.getFirmMsg();
      } else if (
        // data.id == 44 ||
        data.id == 46 ||
        data.id == 47 ||
        data.id == 48 ||
        data.id == 98
      ) {
        if (node.level !== 1 && data.label !== "全部") {
          this.qyflChild.push("规上企业-" + data.label);
          this.qyflChild = [...new Set(this.qyflChild)];
          // console.log('this.qyflChild------',this.qyflChild)
        }

        if (this.tableData.length > 0) {
          this.resetSort();
        }

        this.getFirmMsg();
      } else if (data.id == 49 || data.id == 50 || data.id == 51) {
        if (node.level !== 1 && data.label !== "全部") {
          this.qyfl.push(data.label);

          this.qyfl = [...new Set(this.qyfl)];
        }
        if (this.tableData.length > 0) {
          this.resetSort();
        }
        this.getFirmMsg();
      } else if (
        data.id == "03" ||
        data.id == "04" ||
        data.id == "05" ||
        data.id == "06" ||
        data.id == "07" ||
        data.id == "08" ||
        data.id == "09" ||
        data.id == "10" ||
        data.id == "11" ||
        data.id == "12" ||
        data.id == "13" ||
        data.id == "14" ||
        data.id == "15"
      ) {
        if (node.level !== 1 && data.label !== "全部") {
          this.cnty.push(data.label);
          this.cnty = [...new Set(this.cnty)];
        }

        if (this.tableData.length > 0) {
          this.resetSort();
        }
        this.getFirmMsg();
      } else if (
        data.code == "A01" ||
        data.code == "A21" ||
        data.code == "A22" ||
        data.code == "A23" ||
        data.code == "A24" ||
        data.code == "A41" ||
        data.code == "A42" ||
        data.code == "A43" ||
        data.code == "A44" ||
        data.code == "A45" ||
        data.code == "A46" ||
        data.code == "A47" ||
        data.code == "A61" ||
        data.code == "A62" ||
        data.code == "A63" ||
        data.code == "A99" ||
        data.code == "B01" ||
        data.code == "B02" ||
        data.code == "B03" ||
        data.code == "B04" ||
        data.code == "B05" ||
        data.code == "B06" ||
        data.code == "B07" ||
        data.code == "B08" ||
        data.code == "B09" ||
        data.code == "B21" ||
        data.code == "B22" ||
        data.code == "B23" ||
        data.code == "B24" ||
        data.code == "B25" ||
        data.code == "B26" ||
        data.code == "B27" ||
        data.code == "B28" ||
        data.code == "B29" ||
        data.code == "B30" ||
        data.code == "B31" ||
        data.code == "B32" ||
        data.code == "B41" ||
        data.code == "B42" ||
        data.code == "B43" ||
        data.code == "B44" ||
        data.code == "B60" ||
        data.code == "B61" ||
        data.code == "B62" ||
        data.code == "B63" ||
        data.code == "B64" ||
        data.code == "B65" ||
        data.code == "B66" ||
        data.code == "B67" ||
        data.code == "B68" ||
        data.code == "B81" ||
        data.code == "B82" ||
        data.code == "C01" ||
        data.code == "C02" ||
        data.code == "C03" ||
        data.code == "C04" ||
        data.code == "C05" ||
        data.code == "C06" ||
        data.code == "C07" ||
        data.code == "C08" ||
        data.code == "C09" ||
        data.code == "C10" ||
        data.code == "C11" ||
        data.code == "C12" ||
        data.code == "C13" ||
        data.code == "C14" ||
        data.code == "C21" ||
        data.code == "C22" ||
        data.code == "C23" ||
        data.code == "C25" ||
        data.code == "C30" ||
        data.code == "C40" ||
        data.code == "C99" ||
        data.code == "D01" ||
        data.code == "D02" ||
        data.code == "D03" ||
        data.code == "D04" ||
        data.code == "D05" ||
        data.code == "D06" ||
        data.code == "D07" ||
        data.code == "D21" ||
        data.code == "E01" ||
        data.code == "E02" ||
        data.code == "E03" ||
        data.code == "E04" ||
        data.code == "E05" ||
        data.code == "E06" ||
        data.code == "E21" ||
        data.code == "E26" ||
        data.code == "E99" ||
        data.code == "F99" ||
        data.code == "F01" ||
        data.code == "F02" ||
        data.code == "F03" ||
        data.code == "F04" ||
        data.code == "F15" ||
        data.code == "F16" ||
        data.code == "F17" ||
        data.code == "F21" ||
        data.code == "F22" ||
        data.code == "F23" ||
        data.code == "F24" ||
        data.code == "F25" ||
        data.code == "F26" ||
        data.code == "F27" ||
        data.code == "F28" ||
        data.code == "F41" ||
        data.code == "F42" ||
        data.code == "F99" ||
        data.code == "G01" ||
        data.code == "G02" ||
        data.code == "G03" ||
        data.code == "G04" ||
        data.code == "G05" ||
        data.code == "G06" ||
        data.code == "G07" ||
        data.code == "G08" ||
        data.code == "G09" ||
        data.code == "G10" ||
        data.code == "G11" ||
        data.code == "G12" ||
        data.code == "G21" ||
        data.code == "G99" ||
        data.code == "H01" ||
        data.code == "H02" ||
        data.code == "H03" ||
        data.code == "H04" ||
        data.code == "H05" ||
        data.code == "H99" ||
        data.code == "A63"
      ) {
        // if (node.level !== 1 && data.label !== "全部") {
        this.ipc.push(data.code);
        this.ipcdes.push(data.label);
        this.ipc = [...new Set(this.ipc)];
        this.ipcdes = [...new Set(this.ipcdes)];
        // console.log("-----", this.ipc, "///////", this.ipcdes);
        // }
        if (this.tableData.length > 0) {
          this.resetSort();
        }
        this.getFirmMsg();
      }
      // } else if (
      //   data.id == 52 ||
      //   data.id == 53 ||
      //   data.id == 54 ||
      //   data.id == 55 ||
      //   data.id == 56 ||
      //   data.id == 57 ||
      //   data.id == 58 ||
      //   data.id == 59 ||
      //   data.id == 60 ||
      //   data.id == 61
      // )
      // {
      //   searchName = data.label + "-战略性新兴产业";
      //   this.paramslabel = searchName;
      //   if (this.tableData.length > 0) {
      //     this.resetSort();
      //   }
      //   this.getFirmMsg();
      // }
      else {
        this.getFirmMsg();
      }
    },
    ///////////////////////
    // 左边分类查询

    // 通过点击左边分类获取企业信息
    getFirmMsg(leftType, pageNum = 1, pageSize = 10, order, orderType) {
      this.form.ap = null;
      this.form.frdb = null;
      this.form.apad = null;
      this.form.sclrq = null;
      this.form.eclrq = null;
      this.form.szczb = null;
      this.form.ezczb = null;
      this.form.xydm = null;
      this.multipleSelection = [];
      this.reSearch = false;
      this.isGjcx = false;
      if (this.zdhy) {
        var zdcySrt = [];
        console.log('this.zdhy',this.zdhy)
        this.zdhy.forEach((e, i) => {
          e = e.slice(5);
          zdcySrt.push(e);
        });
      }
      if (this.qyflChild) {
        var qyflChildSrt = [];
        this.qyflChild.forEach((e, i) => {
          e = e.slice(5);
          qyflChildSrt.push(e);
        });
      }
      let form = {
        uid: localStorage.getItem("uid"),
        hyfl: this.hyfl.join(","),
        cnty: this.cnty.join(","),
        zdhy: zdcySrt.join(","),
        // zdhy: this.zdhy.join(),
        qyfl: this.qyfl.join(","),
        ipc: this.ipc.join(","),
        qyflChild: qyflChildSrt.join(","),
        pageNum: pageNum,
        pageSize: pageSize,
        order: order,
        orderType: orderType,
      };

      this.$GET("/applicant/search", form).then((res) => {
        // 数据汇总
        // debugger;
        if (this.typeSearch || JSON.stringify(this.dataSummary) == "{}") {
          this.dataSummary = res.data.countMap;
          this.pageSize = 10;
          this.pageNum = 1;
          this.currentPage = 1;
        }
        this.dataSummary = res.data.countMap;
        // console.log(';',this.dataSummary)
        // 存储表格数据
        let form = res.data.list.records;
        form.forEach((element) => {
          if (element.clrq !== null) {
            element.clrq = element.clrq.split(" ")[0];
          }
          if (element.ls == "1") {
            element.ls = "存续";
          } else if (element.ls == "2") {
            element.ls = "吊销，未注销";
          } else if (element.ls == "3") {
            element.ls = "吊销，已注销";
          } else if (element.ls == "4") {
            element.ls = "注销";
          } else if (element.ls == "5") {
            element.ls = "撤销";
          } else if (element.ls == "6") {
            element.ls = "迁出";
          }
        });
        this.tableData = form;
        this.total = res.data.list.total;
        this.isSearch = true;
        this.gjcxShow = false;
        this.typeSearch = false;
      });
    },
    //   打开企业详情
    openDetails(row) {
      this.$router.push({
        path: "/EnterpriseInfo",
      });
      this.enterbasicDataDetails = row;
      this.$store.commit("enterDetails", this.enterbasicDataDetails);
      // this.detailsFirm = row;
      // this.getzldetails();
      // this.getsbdetails();
      // this.zlList();
      // this.sbList();
      // setTimeout(() => {
      //   this.firmdetails = true;
      // }, 1000);
    },
    // 获取专利列表的方法
    zlList(law, type) {
      this.$get("/patent/apList", {
        token: localStorage.getItem("token"),
        apid: this.detailsFirm.apid,
        law: law,
        type: type,
        pageSize: this.pageSize1,
        pageNum: this.pageNum1,
      }).then((res) => {
        this.tablezldata = res.data.records;
        this.totalzl = res.data.total;
        this.tablezldata.forEach((ele) => {
          if (ele.sPatenttype == "1") {
            ele.sPatenttype = "发明";
          } else if (ele.sPatenttype == "2") {
            ele.sPatenttype = "实用新型";
          } else if (ele.sPatenttype == "3") {
            ele.sPatenttype = "外观设计";
          }
          if (ele.sLawmark == "30") {
            ele.sLawmark = "在审";
          } else if (ele.sLawmark == "20") {
            ele.sLawmark = "无效";
          } else if (ele.sLawmark == "10") {
            ele.sLawmark = "有效";
          }
          if (ele.dtApplydate !== null) {
            ele.dtApplydate = ele.dtApplydate.split(" ")[0];
          }
          if (ele.dtPubdate !== null) {
            ele.dtPubdate = ele.dtPubdate.split(" ")[0];
          }
          if (ele.dtAuthdate !== null) {
            ele.dtAuthdate = ele.dtAuthdate.split(" ")[0];
          }
        });
      });
    },
    // 筛选专利详情
    zlselect1(value) {
      this.currentPage1 = 1;
      //专利分类
      if (value == 0) {
        this.zlTypeselect = "";
      } else if (value == 1) {
        this.zlTypeselect = "3";
      } else if (value == 2) {
        this.zlTypeselect = "1";
      } else if (value == 3) {
        this.zlTypeselect = "2";
      }
    },
    zlselect2(value) {
      this.currentPage1 = 1;
      //法律状态
      let id = value == 4 ? "30" : value == 5 ? "10" : "20";
      if (this.zlLawselect == id) {
        this.zlLawselect = "";
      } else {
        if (value == 4) {
          this.zlLawselect = "30";
        } else if (value == 5) {
          this.zlLawselect = "10";
        } else if (value == 6) {
          this.zlLawselect = "20";
        }
      }
    },
    // 筛选商标详情
    sbselect(value) {
      if (this.sbLawselect == value) {
        this.sbLawselect = "";
      } else {
        this.sbLawselect = value;
        this.currentPage2 = 1;
      }
    },
    // 获取商标列表的方法
    sbList() {
      this.$get("/trademark/getTm", {
        token: localStorage.getItem("token"),
        apid: this.detailsFirm.apid,
        ls: this.sbLawselect,
        pageSize: this.pageSize2,
        pageNum: this.pageNum2,
      }).then((res) => {
        this.tablesbdata = res.data.records;
        this.tablesbdata.forEach((ele) => {
          if (ele.ls == "1") {
            ele.ls = "在审";
          } else if (ele.ls == "2") {
            ele.ls = "有效";
          } else if (ele.ls == "3") {
            ele.ls = "无效";
          }
          if (ele.apd !== null) {
            ele.apd = ele.apd.split(" ")[0];
          }
          if (ele.pd !== null) {
            ele.pd = ele.pd.split(" ")[0];
          }
          if (ele.gd !== null) {
            ele.gd = ele.gd.split(" ")[0];
          }
        });
        this.totalsb = res.data.total;
      });
    },
    // 打开商标基本信息
    // opensb(row) {
    //   this.sbbasicData = true;
    //   this.sbbasicDataDetails = row;
    //   if (this.sbbasicDataDetails.ed !== null) {
    //     this.sbbasicDataDetails.ed = this.sbbasicDataDetails.ed.split(" ")[0];
    //   }
    //   if (this.sbbasicDataDetails.zhlcsj !== null) {
    //     this.sbbasicDataDetails.zhlcsj = this.sbbasicDataDetails.zhlcsj.split(
    //       " "
    //     )[0];
    //   }
    // },
    // 打开专利基本信息
    // openzl(row) {
    //   this.zlbasicData = true;
    //   this.zlbasicDataDetails = row;
    // },

    // 高级查询展开/收起
    handlegjcxShow() {
      if (this.gjcxShow) {
        this.gjcxShow = false;
      } else {
        this.gjcxShow = true;
      }
    },
    GJCXsubmit(pageNum = 1, pageSize = 10, order, orderType) {
      this.paramslabel = "";
      this.multipleSelection = [];
      this.isGjcx = true;
      if (this.zdhy) {
        var zdcySrt = [];
        this.zdhy.forEach((e, i) => {
          e = e.slice(5);
          zdcySrt.push(e);
        });
      }
      if (this.qyflChild) {
        var qyflChildSrt = [];
        this.qyflChild.forEach((e, i) => {
          e = e.slice(5);
          qyflChildSrt.push(e);
        });
      }
      let form = {
        uid: localStorage.getItem("uid"),
        hyfl: this.hyfl.join(","),
        cnty: this.cnty.join(","),
        zdhy: zdcySrt.join(","),
        // zdhy: this.zdhy.join(),
        qyfl: this.qyfl.join(","),
        ap: this.form.ap,
        frdb: this.form.frdb,
        apad: this.form.apad,
        sclrq: this.form.sclrq,
        eclrq: this.form.eclrq,
        szczb: this.form.szczb,
        ezczb: this.form.ezczb,
        xydm: this.form.xydm,

        qyflChild: qyflChildSrt.join(","),
        pageNum: pageNum,
        pageSize: pageSize,
        order: order,
        orderType: orderType,
      };
      // console.log('form',form)
      this.$GET("/applicant/search", form).then((res) => {
        if (res.status == 200) {
          this.isSearch = true;
          if (
            this.typeSearch ||
            this.reSearch ||
            JSON.stringify(this.dataSummary) == "{}"
          ) {
            this.dataSummary = res.data.countMap;
          }
          this.dataSummary = res.data.countMap;
          // console.log('总量数据',this.dataSummary)
          let form = res.data.list.records;
          form.forEach((element) => {
            if (element.clrq !== null) {
              element.clrq = element.clrq.split(" ")[0];
            }
          });
          this.tableData = form;
          this.total = res.data.list.total;
        } else {
          Message({ message: res.msg });
        }
      });
    },
    onSubmit() {
      this.currentPage = 1;
      this.pageSize = 10;
      if (this.tableData.length > 0) {
        this.resetSort();
      }
      // this.getFirmMsg()
      this.GJCXsubmit();
      this.reSearch = true;
    },
    resetData() {
      this.form.ap = "";
      this.form.frdb = "";
      this.form.apad = "";
      this.form.sclrq = "";
      this.form.eclrq = "";
      this.form.szczb = "";
      this.form.ezczb = "";
      this.form.xydm = "";
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChange1(val) {
      this.multipleSelection1 = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    // 分页
    handleSizeChange(val) {
      this.reSearch = false;
      this.pageSize = val;
      if (this.isGjcx) {
        this.GJCXsubmit(this.pageNum, val, this.order, this.orderType);
      } else {
        this.getFirmMsg(
          this.paramslabel,
          this.pageNum,
          val,
          this.order,
          this.orderType
        );
      }
    },
    handleCurrentChange(val) {
      this.reSearch = false;
      this.currentPage = val;
      this.pageNum = val;
      if (this.isGjcx) {
        this.GJCXsubmit(val, this.pageSize, this.order, this.orderType);
      } else {
        this.getFirmMsg(
          this.paramslabel,
          val,
          this.pageSize,
          this.order,
          this.orderType
        );
      }
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.zlList(this.zlLawselect, this.zlTypeselect);
    },
    handleCurrentChange1(val) {
      this.pageNum1 = val;
      this.zlList(this.zlLawselect, this.zlTypeselect);
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.sbList();
    },
    handleCurrentChange2(val) {
      this.pageNum2 = val;
      this.sbList();
    },
    // 排序
    sort(column) {
      this.reSearch = false;
      this.order = column.prop;
      let sortWay;
      if (column.order == "descending") {
        this.orderType = "desc";
        sortWay = "desc";
      } else if (column.order == "ascending") {
        sortWay = "asc";
        this.orderType = "asc";
      }
      if (this.isGjcx) {
        this.GJCXsubmit(this.pageNum, this.pageSize, column.prop, sortWay);
      } else {
        this.getFirmMsg(
          this.paramslabel,
          this.pageNum,
          this.pageSize,
          column.prop,
          sortWay
        );
      }
    },
    // 关闭详情弹框
    closeTkfirmdetails() {
      this.firmdetails = false;
      this.activeName = "first";
      this.zlTypeselect = "";
      this.zlLawselect = "";
      this.sbLawselect = "";
    },
    // 关闭商标基本信息弹框
    closeTksb() {
      this.sbbasicData = false;
    },
    // 关闭专利基本信息弹框
    closeTkzl() {
      this.zlbasicData = false;
    },
    // 获取专利/商标详情数量的方法
    getzldetails() {
      this.detailszlNum = [
        { total: "", faming: "", waiguan: "", shiyong: "" },
        { zaishen: "", youxiao: "", wuxiao: "" },
      ];
      this.$get("/patent/count", {
        token: localStorage.getItem("token"),
        apid: this.detailsFirm.apid,
      }).then((res) => {
        let type = res.data.type;
        let law = res.data.law;
        for (let i = 0; i < type.length; i++) {
          if (type[i].name == "total") {
            this.detailszlNum[0].total = type[i].num;
          } else if (type[i].name == "1") {
            this.detailszlNum[0].faming = type[i].num;
          } else if (type[i].name == "2") {
            this.detailszlNum[0].shiyong = type[i].num;
          } else if (type[i].name == "3") {
            this.detailszlNum[0].waiguan = type[i].num;
          }
        }
        for (let i = 0; i < law.length; i++) {
          if (law[i].name == "10") {
            this.detailszlNum[1].youxiao = law[i].num;
          } else if (law[i].name == "20") {
            this.detailszlNum[1].wuxiao = law[i].num;
          } else if (law[i].name == "30") {
            this.detailszlNum[1].zaishen = law[i].num;
          }
        }
      });
    },
    getsbdetails() {
      this.$get("/applicant/info", {
        token: localStorage.getItem("token"),
        rid: this.detailsFirm.rid,
      }).then((res) => {
        let lsid = res.data.tm.ls;
        lsid.forEach((ele) => {
          if (ele.name == "1") {
            this.detailssbNum.zaishen = ele.num;
            // '在审'
          } else if (ele.name == "2") {
            this.detailssbNum.youxiao = ele.num;
            // '有效'
          } else if (ele.name == "3") {
            this.detailssbNum.wuxiao = ele.num;
            // '无效'
          }
        });
      });
    },
    // 导出Excel
    daochu() {
      var zdcySrt = [];
      if (this.zdhy) {
        this.zdhy.forEach((e, i) => {
          e = e.slice(5);
          zdcySrt.push(e);
        });
      }
      if (this.multipleSelection.length > 0) {
        let zdhy = zdcySrt.join(",");
        console.log("zdhy----", zdhy);
        // 通过a 标签导出
        let aLink1 = document.createElement("a");
        let rids = [];
        this.multipleSelection.forEach((ele) => {
          rids.push(ele.rid);
        });
        let rid = rids.join(";");
        aLink1.href =
          this.$url +
          "/applicant/export?token=" +
          localStorage.getItem("token") +
          "&uid=" +
          localStorage.getItem("uid") +
          "&zdhy=" +
          zdhy +
          "&rids=" +
          rid;
        aLink1.click();
        // document.body.removeChild(aLink);
      } else if (
        this.form.ap !== "" ||
        this.form.frdb !== "" ||
        this.form.apad !== "" ||
        this.form.sclrq == "" ||
        this.form.eclrq == "" ||
        this.form.szczb == "" ||
        this.form.ezczb == "" ||
        this.form.xydm == "" ||
        this.zdhy == ""
      ) {
        // 高级查询 表单
         if (this.zdhy) {
        var zdcySrt = [];
        this.zdhy.forEach((e, i) => {
          e = e.slice(5);
          zdcySrt.push(e);
        });
      }
      
        let aLink3 = document.createElement("a");
        let hyfl = this.hyfl.join();
        let qyfl = this.qyfl.join();
        let zdhy = zdcySrt.join(",");
        console.log("zdhy----", zdhy);
        let qyflChild = this.qyflChild.join();
        let cnty = this.cnty.join();
        let ipc = this.ipc.join();
        aLink3.href =
          this.$url +
          "/applicant/export?token=" +
          localStorage.getItem("token") +
          "&uid=" +
          localStorage.getItem("uid") +
          "&ap=" +
          this.form.ap +
          "&frdb=" +
          this.form.frdb +
          "&apad=" +
          this.form.apad +
          "&sclrq=" +
          this.form.sclrq +
          "&eclrq=" +
          this.form.eclrq +
          "&szczb=" +
          this.form.szczb +
          "&ezczb=" +
          this.form.ezczb +
          "&hyfl=" +
          hyfl +
          "&qyfl=" +
          qyfl +
          "&qyflChild=" +
          qyflChild +
          "&cnty=" +
          cnty +
          "&ipc=" +
          ipc +
          "&zdhy=" +
          zdhy +
          "&xydm=" +
          this.form.xydm +
          "&token=" +
          localStorage.getItem("token");
        aLink3.click();
      }
    },
    daochu1() {
      if (this.multipleSelection1.length > 0) {
        let a = [];
        this.multipleSelection1.forEach((ele) => {
          a.push(ele.sPatentnumber);
        });
        let ans = a.join(";");
        let aLink = document.createElement("a");
        aLink.href =
          this.$url +
          "/patent/export?token=" +
          localStorage.getItem("token") +
          "&apid=" +
          this.detailsFirm.apid +
          "&ans=" +
          ans;
        aLink.click();
      } else {
        let aLink5 = document.createElement("a");
        aLink5.href =
          this.$url +
          "/patent/export?token=" +
          localStorage.getItem("token") +
          "&apid=" +
          this.detailsFirm.apid +
          "&law=" +
          this.zlLawselect +
          "&type=" +
          this.zlTypeselect;
        aLink5.click();
      }
    },
    daochu2() {
      if (this.multipleSelection2.length > 0) {
        let b = [];
        this.multipleSelection2.forEach((ele) => {
          b.push(ele.rid);
        });
        let rids = b.join(";");
        let aLink6 = document.createElement("a");
        aLink6.href =
          this.$url +
          "/trademark/export?token=" +
          localStorage.getItem("token") +
          "&apid=" +
          this.detailsFirm.apid +
          "&rids=" +
          rids +
          "&ls=" +
          this.sbLawselect +
          "&uid=" +
          localStorage.getItem("uid");
        aLink6.click();
      } else {
        let aLink7 = document.createElement("a");
        aLink7.href =
          this.$url +
          "/trademark/export?token=" +
          localStorage.getItem("token") +
          "&apid=" +
          this.detailsFirm.apid +
          "&ls=" +
          this.sbLawselect +
          "&uid=" +
          localStorage.getItem("uid");
        aLink7.click();
      }
    },
    // 重置排序
    resetSort() {
      this.$refs.multipleTable1.sort(this.order, null);
    },
  },
  watch: {
    zlTypeselect() {
      this.pageNum1 = 1;
      this.pageSize1 = 10;
      if (this.firmdetails) {
        this.zlList(this.zlLawselect, this.zlTypeselect);
      }
    },
    zlLawselect() {
      this.pageNum1 = 1;
      this.pageSize1 = 10;
      if (this.firmdetails) {
        this.zlList(this.zlLawselect, this.zlTypeselect);
      }
    },
    sbLawselect() {
      this.pageNum2 = 1;
      this.pageSize2 = 10;
      if (this.firmdetails) {
        this.sbList();
      }
    },
  },
  mounted() {
    // 获取ipc行业分类
    this.applicantIpc();
    // 获取地区权限
    let DataPermission = JSON.parse(localStorage.getItem("DataPermission"));
    // console.log('DataPermission',DataPermission)
    DataPermission.forEach((element, index) => {
      DataPermission[index]["value"] = element.name;
      DataPermission[index]["label"] = element.name;
    });
    // console.log(DataPermission)
    this.optionsRegion = DataPermission;

    let children = [];
    this.optionsRegion.forEach((i) => {
      children.push({
        id: i.id,
        label: i.label,
      });
    });
    this.queryData.forEach((e) => { // push 区域
      if (e.id == 2) {
        e.children = children;
      }
    });
  },
};
</script>
<style>
.query-tag {
  margin-left: 14px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.el-tag.el-tag--info {
  background-color: #fff;
  border-color: #e9e9eb;
  border-radius: 17px;
  color: #5f5f5f;
}
.location {
  width: 220px !important;
  top: 64px !important;
  left: 92px !important;
}
</style>

